import BigNumber from 'bignumber.js'
import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Text from 'UIKit/Text'
import TokenLogo from 'UIKit/TokenLogo'
import { HUSD_TOKEN } from 'config/constants/tokens'
import { RowBetween } from 'layout/Components/Row'
import { useEffect } from 'react'
import { Trans } from 'react-i18next'
import { useAirdropHistory } from 'state/bonus/hooks'
import { getFullDisplayBalance } from 'utils/formatBalance'

export const SummaryAirdrop: React.FC = () => {
  const { fetchData, totalReceivedAirdrop, totalAmount } = useAirdropHistory()

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <Box py={20}>
      <RowBetween mb={20}>
        <Text color="#232C3D" fontSize="14px" fontWeight={400} lineHeight="normal" letterSpacing="-0.28px">
          <Trans>Received</Trans>
        </Text>
        <Flex style={{ gap: '4px' }}>
          <Text color="#161C24" fontSize="14px" fontWeight={500} lineHeight="20px" letterSpacing="-0.28px">
            {totalReceivedAirdrop ?? 0}
          </Text>
          <Text color="textAlt1" fontSize="14px" fontWeight={500} lineHeight="20px" letterSpacing="-0.28px">
            <Trans>Airdrops</Trans>
          </Text>
        </Flex>
      </RowBetween>
      <RowBetween>
        <Text color="#232C3D" fontSize="14px" fontWeight={400} lineHeight="normal" letterSpacing="-0.28px">
          <Trans>Total</Trans>
        </Text>
        <Flex style={{ gap: '4px' }}>
          <TokenLogo token={HUSD_TOKEN} size={20} />
          <Text color="#161C24" fontSize="14px" fontWeight={500} lineHeight="20px" letterSpacing="-0.28px">
            {getFullDisplayBalance(new BigNumber(totalAmount ?? 0), 0, 4)}
          </Text>
          <Text color="textAlt1" fontSize="14px" fontWeight={500} lineHeight="20px" letterSpacing="-0.28px">
            <Trans>HUSD</Trans>
          </Text>
        </Flex>
      </RowBetween>
    </Box>
  )
}
